import React from "react";
import { WhatsappLogo } from "@phosphor-icons/react";
import { useLang } from "@/lib/LanguageContext";
import { wa } from "@/lib/pfd";

const StickyWhatsApp = () => {
  const { t } = useLang();
  return (
    <a
      data-testid="sticky-whatsapp"
      href={wa(t.home.waMsgPrimary)}
      target="_blank"
      rel="noreferrer"
      aria-label="Contact us on WhatsApp"
      className="fixed bottom-[max(1.5rem,env(safe-area-inset-bottom))] right-6 z-50 sm:hidden flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg hover:bg-[#20BD5A] transition-colors"
    >
      <WhatsappLogo size={26} weight="fill" />
    </a>
  );
};

export default StickyWhatsApp;
